import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';

import { MobileSdkIssueDetailsQueryVariables } from '../MobileSdkIssueDetails.generated';

const ISSUE_ID_PARAM_NAME = 'issueId';
const TEST_ID_PARAM_NAME = 'testId';

export const buildMobileSdkIssueDetailsVariables = (
	issueId: string,
	testId: string
): MobileSdkIssueDetailsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileSdkIssueDetailsQueryVariables>();

	return variablesBuilder
		.addConditionParam(ISSUE_ID_PARAM_NAME, issueId)
		.addConditionParam(TEST_ID_PARAM_NAME, testId)
		.getVariables();
};
